import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { arrayUnion, doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

const StatusContext = createContext();

export function StatusProvider({ children }) {
  const auth = getAuth();
  const [viewedStatuses, setViewedStatuses] = useState(new Set());
  const [currentUser, setCurrentUser] = useState(null);

  // Track auth state changes
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);
      if (user) {
        // Load user's viewed statuses
        const userRef = doc(db, 'users', user.uid);
        try {
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            const userData = userSnap.data();
            const viewed = userData.viewedStatuses || [];
            setViewedStatuses(new Set(viewed));
          }
        } catch (error) {
          console.error('Error loading viewed statuses:', error);
        }
      } else {
        setViewedStatuses(new Set());
      }
    });
    return () => unsubscribe();
  }, [auth]);

  // Update both local state and database when a status is viewed
  const markStatusAsViewed = async (statusId) => {
    if (!currentUser) return;

    try {
      // Update local state
      setViewedStatuses(prev => new Set([...prev, statusId]));
      
      // Update database
      const userRef = doc(db, 'users', currentUser.uid);
      await updateDoc(userRef, {
        viewedStatuses: arrayUnion(statusId)
      });
    } catch (error) {
      console.error('Error marking status as viewed:', error);
    }
  };

  return (
    <StatusContext.Provider value={{ 
      viewedStatuses, 
      markStatusAsViewed,
      currentUser
    }}>
      {children}
    </StatusContext.Provider>
  );
}

export function useStatusContext() {
  return useContext(StatusContext);
}